<template>
  <div class="order_box">
    <el-tabs v-model="activeName"
             @tab-click="handleClick">
      <el-tab-pane :label="item.label"
                   :name="item.name"
                   v-for="(item,index) in list"
                   :key="index"></el-tab-pane>
    </el-tabs>
    <div style="height:20px;width:100%;background-color: #f5f5f5;"></div>
    <el-tabs v-model="activeName2"
             @tab-click="handleClick2">
      <el-tab-pane :label="item.label"
                   :name="item.name"
                   v-for="(item,index) in list2"
                   :key="index"></el-tab-pane>
    </el-tabs>
    <el-table :data="tableData"
              border
              style="width: 100%">
      <el-table-column prop="test1"
                       align="center"
                       label="订单号">
      </el-table-column>
      <el-table-column prop="test2"
                       align="center"
                       width="150"
                       label="下单时间">
      </el-table-column>
      <el-table-column prop="test3"
                       align="center"
                       label="课程信息">
      </el-table-column>
      <el-table-column prop="test4"
                       align="center"
                       label="类型">
      </el-table-column>
      <el-table-column prop="test5"
                       align="center"
                       label="价格">
      </el-table-column>
      <el-table-column prop="test6"
                       align="center"
                       label="实付金额">
      </el-table-column>
      <el-table-column prop="test7"
                       align="center"
                       label="支付方式">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data () {
    return {
      tableData: [{ test1: '5225545255222', test2: '2022-11-01 11:58', test3: '金牌店长——巡店管理、会 议激发与数据分析', test4: '线上课程', test5: '￥3000.00', test6: '￥3000.00', test7: '微信支付' }, { test1: '5225545255222', test2: '2022-11-01 11:58', test3: '金牌店长——巡店管理、会 议激发与数据分析', test4: '线上课程', test5: '￥3000.00', test6: '￥3000.00', test7: '微信支付' }, { test1: '5225545255222', test2: '2022-11-01 11:58', test3: '金牌店长——巡店管理、会 议激发与数据分析', test4: '线上课程', test5: '￥3000.00', test6: '￥3000.00', test7: '微信支付' }, { test1: '5225545255222', test2: '2022-11-01 11:58', test3: '金牌店长——巡店管理、会 议激发与数据分析', test4: '线上课程', test5: '￥3000.00', test6: '￥3000.00', test7: '微信支付' }],
      activeName: 0, activeName2: 0,
      list: [{ label: '线下活动', name: 0 }, { label: '会员卡', name: 1 }],
      list2: [{ label: '全部订单', name: 0 }, { label: '待支付', name: 1 }, { label: '已支付', name: 2 }]
    }
  },
  methods: {
    handleClick (tab, event) {
      this.activeName = Number(tab.index)
      console.log(this.activeName)
    },
    handleClick2 (tab, event) {
      this.activeName2 = Number(tab.index)
    },
  }

}
</script>
<style lang="less" scoped>
.tabs__header {
  margin: 0 !important;
}
</style>